export const OnMouseDown = {
  mounted() {
    this.el.addEventListener('mousedown', (event) => {
      if (this.el == event.target) {
        liveSocket.execJS(this.el, this.el.dataset.mousedownEvent);
      }
    });
  },
};
